import Splide from '@splidejs/splide'
import { getElOrFalse } from './utils'
import { FadeBlurTransition } from './slideshow-transitions'

function fullSlider(slider: HTMLElement) {
    let pagination = !slider.classList.contains('splide--no-paging')
    let arrows = slider.querySelector('.splide__arrows') ? true : false

    let splide = new Splide(slider, {
        autoplay: true,
        type: 'fade',
        rewind: true,
        arrows,
        pagination,
        easing: 'cubic-bezier(.645,0.045,.355,1)', // in out cubic
        speed: 1200,
    })

    splide.mount()
}

function ftProjectSlider(container: HTMLElement) {
    let data = container.dataset

    if (+data.count > 3) {
        new Splide(container, {
            perPage: 1,
            pagination: false,
            type: 'slide',
            arrows: true,
            mediaQuery: 'min',
            autoplay: container.dataset.hasOwnProperty('autoplay'),
            breakpoints: {
                720: {
                    perPage: 3,
                    gap: '0.325rem',
                    perMove: 1,
                },
                1200: {
                    gap: '0.625rem',
                },
            },
        }).mount()
    } else if (+data.count > 1) {
        new Splide(container, {
            perPage: 1,
            pagination: false,
            type: 'slide',
            arrows: true,
            mediaQuery: 'min',
            autoplay: container.dataset.hasOwnProperty('autoplay'),
            breakpoints: {
                720: {
                    destroy: true,
                },
            },
        }).mount()
    }
}

function expandedInfoSlider(container: HTMLElement) {
    let contents = getElOrFalse(container.querySelector('.expslider__contents.splide'))
    let images = getElOrFalse(container.querySelector('.expslider__images.splide'))

    if (!contents || !images) return

    let contentSplide = new Splide(contents, {
        arrows: true,
        perPage: 1,
        type: 'fade',
        pagination: false,
        isNavigation: true,
        rewind: false,
    })

    let imgSplide = new Splide(images, {
        mediaQuery: 'min',
        direction: 'ttb',
        perPage: 1.5,
        perMove: 1,
        arrows: false,
        pagination: false,
        height: '120vw',
        gap: '0.625rem',
        type: 'loop',
        rewind: false,
        breakpoints: {
            576: {
                height: '90vw',
            },
            635: {
                height: '',
                heightRatio: 1.05,
            },
            1024: {
                heightRatio: 0,
                direction: 'ltr',
                perPage: 1.5,
            },
            1200: {
                perPage: 2.5,
            },
        },
    })

    imgSplide.sync(contentSplide)
    imgSplide.mount()
    contentSplide.mount()
}

function expandedSliderTimeline(el: HTMLElement) {
    let style = el.classList.contains('expslider--square') ? 'square' : 'landscape'
    let slider = getElOrFalse(el.querySelector('.splide'))
    if (!slider) return

    let splide = new Splide(slider, {
        arrows: true,
        type: 'loop',
        pagination: false,
        rewind: false,
        focus: 'center',
        updateOnMove: true,
        mediaQuery: 'min',
        gap: style === 'square' ? '3.9%' : '5.5%',
        fixedWidth: style === 'square' ? '39%' : '70%',
        speed: 500,
        breakpoints: {
            720: {
                gap: style === 'square' ? '3.5%' : '4.5%',
                fixedWidth: style === 'square' ? '39%' : '60%',
            },
            1024: {
                fixedWidth: style === 'square' ? '27%' : '55%',
                gap: style === 'square' ? '2.5%' : '4%',
            },
            1600: {
                gap: style === 'square' ? '2%' : '3.5%',
                fixedWidth: style === 'square' ? '24%' : '48%',
            },
        },
    })

    splide.mount()
}

export function initSliders() {
    let expandedSliders = document.querySelectorAll('.expslider__wrap')
    expandedSliders.forEach((el: HTMLElement) => expandedInfoSlider(el))

    let expSliderTl = document.querySelectorAll('.expslider--tl')
    expSliderTl.forEach((el: HTMLElement) => expandedSliderTimeline(el))

    let ftProjects = document.querySelectorAll('.ftproj .splide')
    ftProjects.forEach((el) => {
        if (el instanceof HTMLElement) ftProjectSlider(el)
    })

    let fullSliders = document.querySelectorAll(
        '.hero--slideshow .splide, .halfhero--slideshow .splide, .medtext--slideshow .splide'
    )
    fullSliders.forEach((el) => {
        if (el instanceof HTMLElement) fullSlider(el)
    })
}
